module.exports = __webpack_public_path__ + "public/img/Sale03.5b690af9.png";